<template>
  <div>
    <el-card class="flex flex-center">
      <div style="margin-bottom: 10px">
        <span>请输入优惠券序列号</span>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="优惠券序列号" prop="couponCode">
          <div>
            <el-input
              size="small"
              clearable
              placeholder="请输入优惠券序列号"
              v-model.trim="ruleForm.couponCode"
            ></el-input>
            <!--  <el-button size="small"   type="primary">查询</el-button> -->
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="region">
          <el-input
            size="small"
            clearable
            type="textarea"
            :rows="5"
            :cols="45"
            v-model.trim="remark"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="text-center">
            <el-button size="small" type="primary" @click="use('ruleForm')"
              >确认核销</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      remark: "",
      ruleForm: {
        couponCode: ""
      },
      rules: {
        couponCode: [
          { required: true, message: "请输入优惠券序列号", trigger: "blur" }
        ]
      }
    };
  },
  computed: mapState({
    cancelAfterVerificationCode: state =>
      state.rules.cancelAfterVerificationCode
  }),
  watch: {
    cancelAfterVerificationCode(val) {
      if (val === "0") {
        this.$message({
          message: "核销成功",
          type: "success"
        });
      }
      this.$store.commit("cancelAfterVerification", "");
    }
  },
  methods: {
    use(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$store.dispatch("cancelAfterVerification", {
            couponCode: this.ruleForm.couponCode,
            remark: this.remark
          });
        }
      });
    }
  }
};
</script>
